export default {
      id: "arrow-down-usage",
      viewBox: "0 0 16 11",
      url: __webpack_public_path__ + "img/icons.159f8dce.svg#arrow-down",
      toString: function () {
        return this.url;
      }
    }